import React from "react";

import LayoutWeb from "./LayoutWeb";

import _get from "lodash.get"

import Stack from "components/common/Stack";



// Pages list which does't have layout.
const withoutLayoutPages = [
    "/customer/jarvis-info",
    "/customer/product-info",
    

    "/customer/dashboard",
    "/customer/holdings",
    "/customer/market-pulse",
    "/customer/blogs",
    "/customer/profile",
    "/customer/profile/subscription",
    "/customer/profile/edit-profile",


    "/customer/product-list",
    "/customer/broker",
    "/customer/document-signing",
    "/customer/subscription",
    "/customer/payment",
    "/customer/onetime-payment",
];



// Render pages without layout handling.
const WithoutLayout = (props) => {
    const { children } = props;

    return (
        <Stack
            sx={{
                minHeight: "calc(100vh - (var(--safe-area-inset-top) + var(--safe-area-inset-bottom)))",
            }}>
            {children}
        </Stack>
    )
}


class LayoutContainer extends React.Component {
        constructor(props){
            super(props);
            this.state = {}
        }

    componentDidMount(){
    }


    render() {
        const pathname = _get(this.props, "location.pathname", "");
        const noLayout =
            withoutLayoutPages.includes(pathname) ||
            pathname.startsWith("/customer/market-pulse") ||
            pathname.startsWith("/customer/product-info");

        if (noLayout) {
            return <WithoutLayout {...this.props} />
        }

        // All-in-One dashboard chrome (top nav / product nav) for WEB, ANDROID, and IOS.
        // Legacy LayoutMobileApp (old product tabs + bottom nav) is no longer used.
        return <LayoutWeb {...this.props} />;
    }
}

export default LayoutContainer;
